export const CINCH_CAR_ACCOUNT_ID = 94525129;

export const CINCH_CAR_VIP_ALTERNATIVE_LOCATION_TEXT =
    'Free Delivery Or Collection From 100+ Sites';
